import { render, staticRenderFns } from "./dangjiantest.vue?vue&type=template&id=02320dba&scoped=true&"
import script from "./dangjiantest.vue?vue&type=script&lang=js&"
export * from "./dangjiantest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02320dba",
  null
  
)

export default component.exports